import React from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Button } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
import {
  addTrainerModal,
  setCourtModal,
} from "../../redux/actions/sidebar/sidebarAction";
import { store } from "../../redux/storeConfig/store";
import { setTrainerCount } from "../../redux/actions/trainer/trainerAction";

export const StepButton = (props) => {
  const { gym } = useSelector((state) => state.gym);
  const dispatch = useDispatch();
  return (
    <>
      <div className="action-wrapper blk-padding-y">
        <div className="action-inner-block">
          <div className="action-btn-block">
            <span
              value="Previous"
              className="btn btn-medium btn-transparent"
              onClick={(e) => {
                e.preventDefault();
                dispatch(setCourtModal(false));
              }}
            >
              Cancel
            </span>
            <button
              value="Add Instructor"
              className="btn btn-medium"
              type="submit"
            >
              {gym.type === "sportClub" ? "Add Court" : " Add Room"}{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
